import {
  FabQueryStateType,
  GetFabImagesQueryParamsType,
} from '@/modules/adjusterReportModules/adjusterReport/queries/imageFab/getFabImages/getFabImagesQuery.type';
import { getFabImagesFunction } from '@/modules/adjusterReportModules/adjusterReport/queries/imageFab/getFabImages/getFabImagesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getFabImagesQueryOptions = (
  params: GetFabImagesQueryParamsType,
) => {
  const generateUrl = (state: FabQueryStateType) => {
    switch (state) {
      case 'bodyAdjusterDocument':
        return `body/reports/${params.id}/fab/adjuster/document/`;
      case 'bodyCustomerDocument':
        return `body/reports/${params.id}/fab/customer/document/`;
      case 'initialAdjusterDocument':
        return `initial/reports/${params.id}/fab/adjuster/document/`;
      case 'initialCustomerDocument':
        return `initial/reports/${params.id}/fab/customer/document/`;
      case 'propertyCulpritAdjusterDocument':
        return `property/reports/${params.id}/accident_users/culprit/fab/adjuster/document/`;
      case 'propertyCulpritCustomerDocument':
        return `property/reports/${params.id}/accident_users/culprit/fab/customer/document/`;
      case 'propertyDamagedAdjusterDocument':
        return `property/reports/${params.id}/accident_users/damaged/fab/adjuster/document/`;
      case 'propertyDamagedAdjusterDamagedPerson':
        return `property/reports/${params.id}/accident_users/damaged/fab/adjuster/damaged/`;
      case 'propertyDamagedCustomerDamagedPerson':
        return `property/reports/${params.id}/accident_users/damaged/fab/customer/damaged/`;
      case 'propertyDamagedCustomerDocument':
        return `property/reports/${params.id}/accident_users/damaged/fab/customer/document/`;

      default: {
        // check that all state items exist in switch case if u see error - a case not exist
        const typeCheck: never = state;
        return typeCheck;
      }
    }
  };
  return queryOptions({
    queryKey: ['FabImages', params],
    queryFn: () =>
      getFabImagesFunction({
        url: generateUrl(params.state),
        damagedId: params.damagedId,
      }),
    enabled: true,
  });
};
